import { Injectable } from "@angular/core";
import { DRCTMedia } from "@drct-web-apps/ui-types";



@Injectable({
    providedIn: 'root'
})
export class UiServicesMedia {

    private _mediaMode = 'new';
    get mediaMode(): string {
        return this._mediaMode;
    }
    set mediaMode(value: string) {
        this._mediaMode = value;
    }

    private _mediaInfo: DRCTMedia | null = null;
    get mediaInfo(): DRCTMedia | null {
        return this._mediaInfo;
    }
    set mediaInfo(value: DRCTMedia | null) {
        this._mediaInfo = value;
    }
}